import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Reveal, Eyebrow, MaskedLine } from "@/components/Reveal";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Message received. We move quietly, but we reply.");
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error("Something went wrong. Try again.");
    } finally {
      setSending(false);
    }
  };

  const field = "w-full bg-transparent border border-white/15 px-5 py-4 text-sm placeholder:text-cream/30 focus:outline-none focus:border-gold/60 transition-colors";

  return (
    <div className="pt-16" data-testid="contact-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-24 sm:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <Reveal><Eyebrow>Contact</Eyebrow></Reveal>
            <h1 className="font-display font-extrabold uppercase tracking-tight text-5xl sm:text-6xl mt-4 leading-[0.9]">
              <MaskedLine delay={0.1}><span className="text-cream">Reach</span></MaskedLine>
              <MaskedLine delay={0.2}><span className="text-outline">Out</span></MaskedLine>
            </h1>
            <Reveal delay={0.3}>
              <p className="mt-8 text-cream/50 text-sm leading-relaxed max-w-md">
                Sizing questions, press, wholesale, collaborations — or just to say the message landed. We read everything.
              </p>
            </Reveal>
            <Reveal delay={0.4}>
              <div className="mt-12 space-y-6 font-mono2 text-xs tracking-[0.2em] uppercase text-cream/50">
                <p>support@jaenoir.com</p>
                <p>Miami, Florida — Everglades Edge</p>
                <p className="text-gold/70">Replies within 48 hours</p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.2}>
            <form onSubmit={submit} className="space-y-4 lg:pt-24" data-testid="contact-form">
              <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Name" className={field} data-testid="contact-name-input" />
              <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className={field} data-testid="contact-email-input" />
              <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Your message" className={`${field} resize-none`} data-testid="contact-message-input" />
              <button type="submit" disabled={sending} className="w-full bg-gold text-noir-bg font-mono2 text-[11px] tracking-[0.25em] uppercase py-4 hover:bg-cream transition-colors duration-300 disabled:opacity-50" data-testid="contact-submit-button">
                {sending ? "Sending…" : "Send Message"}
              </button>
            </form>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
